module.exports = __webpack_public_path__ + "media/vid-ig-embed-code.77f421fb.webm";